import React from 'react';
import VCard from 'vcard-creator';
import FileSaver from 'file-saver';

import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';

const VCardFileCreator = (props) => {
  const user = props.user;
  const source = props.source;

  const myVCard = new VCard();
  myVCard
    // Add personal data
    .addName(user.firstName, user.lastName, '', '', '')
    .addEmail(user.email)
    .addPhoneNumber(user.mobile, 'WORK')
    .addURL(user.companyLink)
    .addCompany(user.companyName);

  const downloadFile = (e) => {
    e.preventDefault();

    console.log(user);
    console.log(myVCard.toString());

    const file = new Blob(
      [
        `${myVCard.toString()}
`,
      ],
      { type: 'text/vcard;charset=utf-8' },
    );

    let a = document.createElement('a');
    a.download = `${user.firstName}.vcf`;
    a.href = URL.createObjectURL(file);
    var reader = new FileReader();
    if (navigator.userAgent.match('CriOS')) {
      reader.onloadend = (e) => {
        window.open(reader.result);
      };
      reader.readAsDataURL(file);
    } else if (navigator.userAgent.match(/iPad|iPhone|Android/i)) {
      reader.onload = (e) => {
        window.location.href = reader.result;
      };
      reader.readAsDataURL(file);
    } else {
      FileSaver.saveAs(file, `${user.firstName}.vcf`, true);
    }
  };

  const totalNameLength = user.firstName.length + user.lastName.length;

  if (totalNameLength > 15) {
    user.lastName = user.lastName.slice(0, 1) + '.';
  }

  return (
    <>
      {source === 'icon' && (
        <a
          href='https://the100club.io'
          onClick={downloadFile}
          className='bg-primary-main text-white p-3 rounded-full'>
          <PermContactCalendarIcon />
        </a>
      )}
      {source == null && (
        <a href='https://the100club.io' onClick={downloadFile} className={`${props.className}`}>
          {user.firstName} {user.lastName}
        </a>
      )}
    </>
  );
};

export default VCardFileCreator;
